import { render, staticRenderFns } from "./DinersSvg.vue?vue&type=template&id=23ebb292&scoped=true&"
import script from "./DinersSvg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DinersSvg.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ebb292",
  null
  
)

export default component.exports